<template>
  <v-app id="app">
    <v-container fluid  class="px-md-16">
      <v-app-bar
        color="transparent"
        flat
      >
        <div class="d-flex align-center" @click="$router.push('/')" style="cursor: pointer">
          <v-img
            alt="Attorney General's Office"
            class="shrink mr-2"
            contain
            src="logo.png"
            transition="scale-transition"
            width="40"
          />

          <v-img
            alt="Attorney General's Office"
            class="shrink mt-1 hidden-sm-and-down"
            contain
            min-width="100"
            src="name.png"
            width="300"
          />
          <v-img
            alt="Attorney General's Office"
            class="shrink mt-1 hidden-sm-and-up"
            contain
            min-width="100"
            src="name.png"
            width="200"
          />
        </div>
        <v-spacer></v-spacer>
        <v-menu
          left
          bottom
          v-for="(value, key) in navItems"
          :key="key"
          :rounded="false"
          offset-y
          light
          :allow-overflow="true"
          content-class="elevation-1 "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              v-bind="attrs"
              v-on="on"
              dense
              class="font-weight-bold d-none d-md-flex caption"
              :class="$route.params.category === key ? 'active-link' : ''"
              tile
            >
              {{key}}
            </v-btn>
          </template>

          <!-- style="opacity: 0.95" -->
          <v-list 
          dense
          class="elevation-0"
          style="opacity: 0.95"
          >
            <v-list-item
              v-for="(n) in value"
              :key="n"
              :href="n === 'Laws of the Maldives' ? 'https://mvlaw.gov.mv/dv' : n === 'Laws and Regulations' ? 'https://www.mvlaw.gov.mv' : `#/${key}/${n}`"
            >
              <v-list-item-title class="font-weight-regular">{{n === "Why Join AGO" ? n + '?' : n}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          light
          depressed
          text
          class="hidden-sm-and-down dhivehi"
          href="/dhi"
        >
          ދިވެހި <img :src="'dhivehi-logo.png'" width="30px" class="pa-1" alt="">
        </v-btn>
        <v-menu
          right
          bottom
          :rounded="false"
          offset-y
          light
          content-class="elevation-1 white"
          :close-on-content-click="false"
          min-width="300"

        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              v-bind="attrs"
              v-on="on"
              class="font-weight-regular  d-flex d-md-none"
            >
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </template>
          <v-list>
          <v-list-group
          dense
          class="elevation-0"
          v-for="(value, key) in navItems"
          :key="key"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{key}}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="n in value"
              :key="n"
              :href="n === 'Laws of the Maldives' ? 'https://mvlaw.gov.mv/dv' : n === 'Laws and Regulations' ? 'https://www.mvlaw.gov.mv' :  `#/${key}/${n}`"
              link
              style="background-color: #e1e3f9"
            >
              <v-list-item-title class="font-weight-light">{{n === "Why Join AGO" ? n + '?' : n}}</v-list-item-title>
              <v-divider></v-divider>
            </v-list-item>
          </v-list-group>
          <v-list-item>
            <v-list-item-title href="" class="font-weight-light">
              <v-btn
                light
                depressed
                text
                class="dhivehi"
                href="/dhi"
              >
                ދިވެހި <img :src="'dhivehi-logo.png'" width="30px" class="pa-1" alt="">
              </v-btn>
            </v-list-item-title>
          </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>
    </v-container> 

    <v-main  class="px-md-16" style="min-height: 80vh">
      <v-container fluid>
        <router-view :key="$route.fullPath" :navItems="navItems"></router-view>
      </v-container>
    </v-main>

    <div class="grey lighten-3 py-6">
      <div class="px-md-16">
        <v-container fluid>
          <v-img
            alt="Vuetify Name"
            class="shrink mt-1"
            contain
            min-width="100"
            src="name.png"
            width="300"
          />

          <v-row justify="space-between">
            <v-col
              v-for="(value, key) in navItems"
              :key="key"
              cols="12"
              md="2"
            >
              <p class="title primary--text">{{key}}</p>
              <p
              v-for="n in value"
              :key="n"
              class="ma-0 font-weight-light"
              >
              <a :href="n === 'Laws of the Maldives' ? 'https://mvlaw.gov.mv/dv' : n === 'Laws and Regulations' ? 'https://www.mvlaw.gov.mv' :  `#/${key}/${n}`" style="color: #0e0e0e !important;">{{n === "Why Join AGO" ? n + '?' : n}}</a>
              </p>
            </v-col>
            <v-col>
              <v-btn icon>
                <v-icon>mdi-facebook</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-twitter</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-instagram</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <p class=" font-weight-ligh r-2 mt-3">© Attorney General's Office 2020</p>
        </v-container>
      </div>
      
    </div>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',

  components: {
    HelloWorld,
  },

  data: () => ({
    navItems: {}
  }),
  mounted() {
    const fetchNav = async () => {
      let response = await fetch('/pages.json')
      this.navItems = await response.json()
    }
    fetchNav()
    this.$http.get(`${this.$url}/pagination/2/Attorney%20General/Attorney%20General?limit=20&page=0&sort=id%20desc`).then((response) => {
      let attorneyGeneral= response.data.data.rows.filter(item => item.Title.includes('#'))[0]
      this.navItems['Attorney General'].splice(0,0, attorneyGeneral.Title.split('#')[1])
    })
  }
};
</script>
<style>
@font-face {
  font-family: 'MV Faseyha';
  src: url('./assets/fonts/mv_faseyha.woff') format('woff');
}
@font-face {
  font-family: 'Lato';
  src: url('./assets/fonts/Lato-Regular.ttf') format('ttf');
}

.dhivehi {
  font-family: 'MV Faseyha', sans-serif;
}
a {
  text-decoration: none
}
.title-div, .title-div>a {
  /* background-color: rgb(21 113 179 / 98%); */
  background-color: #00057A;
  color: white !important;
}
.v-list-item--active {
  background-color: white
}
a, .v-list-item--active {
  color: #0007c7 !important;
}
.active-link {
  /* border-bottom-color: rgb(21 113 179 / 98%) !important; */
  border-bottom-color: #0007c7 !important;
  border-bottom-width: 4px;
  border-bottom-style: solid;
  /* color: rgb(21 113 179 / 98%) !important; */
  color: #0007c7 !important;
}
.attorney-dates p {
  line-height: 1rem;
}
.box-title {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 16px;
}
.ql-editor p,.ql-editor ul li, .ql-editor ol li, .v-list-item__title{
  line-height: 1.66667;
  font-size: 16px;
  letter-spacing: 0.17px;
  font-family: 'Lato', sans-serif;;
  /* text-align: justify !important;  */
}
.ql-editor ul, ol {
  margin-bottom: 16px !important;
}
ul li, ol li {
  margin-bottom: 13px;
}
body {
  -webkit-font-smoothing: antialiased;
  font-family: 'Lato', sans-serif;;
}
#app, .theme--light.v-tabs > .v-tabs-bar {
  background-color: var(--v-background-base) !important;
}
.v-list-group__header {
  /* background-color: #4b51fb; */
}
.v-list-group__header>div>div, .v-list-group__header__append-icon>i {
  color: rgb(0, 123, 250) !important;
}
.v-list-group__items {
  background: #0072ff2b;
}
</style>
